module.exports = __webpack_public_path__ + "assets/img/D3-Security-Content-Marketing-w540.6fc66df4.webp";